<template>
  <v-alert type="warning" border="top" dense v-bind="$attrs" v-on="$listeners" v-if="shouldShowAlert">
    {{ message ? message : errors.message }}
    <div v-if="showValidationErrors && availableValidationErrors">
      <ul>
        <li
          v-for="(key, i) in Object.keys(errors.validationErrors)"
          :key="i"
          :style="{ margin: '0px', padding: '0px' }"
        >
          {{ shouldDisplayFieldLabel(key) ? firstLetterToUpperCase(key) + ": " : "" }}
          <span v-for="(error, j) in splitErrors(errors.validationErrors[key])" :key="j">
            {{ error }}
            <br v-if="j < splitErrors(errors.validationErrors[key]).length - 1" />
          </span>
        </li>
      </ul>
    </div>
  </v-alert>
</template>

<script>
export default {
  name: "ApiError",
  props: {
    errors: {
      type: Object,
      default: null
    },
    message: {
      type: String,
      default: null
    },
    showValidationErrors: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    isNumeric(str) {
      if (typeof str != "string") return false;
      return !isNaN(str) && !isNaN(parseFloat(str));
    },
    firstLetterToUpperCase(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    /**
     * Field keys are for mapping violations. Show a prefix only for human-readable
     * labels (e.g. "Minimum claimable units"). API property paths
     * (e.g. claimProduct, claimProduct.serialNumber) display the message alone.
     */
    shouldDisplayFieldLabel(key) {
      if (!key || this.isNumeric(key) || key === "null") {
        return false;
      }
      return !/^[A-Za-z_][\w]*(\.[A-Za-z_][\w]*)*$/.test(key);
    },
    splitErrors(errorMessages) {
      return errorMessages.split("\n");
    }
  },
  computed: {
    shouldShowAlert() {
      return (
        this.message ||
        (this.errors?.validationErrors && Object.keys(this.errors.validationErrors).length > 0) ||
        this.errors?.message
      );
    },
    availableValidationErrors() {
      return this.errors?.validationErrors && Object.keys(this.errors.validationErrors).length > 0;
    }
  }
};
</script>
